<svg width="796" height="556" viewBox="0 0 796 556" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M796 349C796 541.747 541.747 556 349 556C156.253 556 0 399.747 0 207C0 14.2526 254.253 0 447 0C639.747 0 796 156.253 796 349Z" fill="#36117C"/>
</svg>
